import { useNavigate, useParams } from "react-router-dom";
import { CircleChevronRight } from "lucide-react";

import { useAuth } from "../../contexts/auth-context";
import { base64PDFToBlobUrl } from "../../lib/utils";
import { usePatientHealthRecords } from "../../lib/hooks/doctors/use-patient-health-records";

import { useToast } from "../../components/ui/use-toast";
import { Button } from "../../components/ui/button";
import BackIcon from "../../components/back-icon";

import { PrescriptionIcon } from "./prescriptions";

function RecordPrescriptions() {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { recordId } = useParams();

  const { mobile } = useAuth();
  const selectedPatient = localStorage.getItem("selectedPatient");

  const { healthRecords = [], isLoading } = usePatientHealthRecords({
    name: selectedPatient ?? "",
    mobile: mobile ?? "",
  });

  const record = recordId
    ? healthRecords.find((record) => record.recordId === parseInt(recordId))
    : null;

  function handleViewPrescription(prescription: string) {
    if (!prescription)
      return toast({
        title: "Consolidated report not found",
        variant: "destructive",
      });

    const mimeType = prescription.split(",")[0].split(":")[1].split(";")[0];
    const blobUrl = base64PDFToBlobUrl(mimeType, prescription.split(",")[1]);

    window.open(blobUrl);
  }

  return (
    <div className="container py-6">
      <div className="mb-4 flex items-center gap-2">
      <div className="relative group">
  <Button size="icon" variant="ghost" onClick={() => navigate(-1)}>
    <BackIcon />
  </Button>

  <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:flex items-center px-2 py-1 rounded text-xs text-white bg-gray-800 shadow-lg">
    Go Back
  </span>
</div>

        <h2 className="font-bold sm:text-lg">Health Record</h2>
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div>
          {!record?.uploadRecords.length && <p>No prescriptions uploaded</p>}
          <ul className="grid gap-4 sm:grid-cols-2 md:gap-8 lg:grid-cols-3 2xl:grid-cols-4">
            {record?.uploadRecords.map((report) => (
              <li
                key={report.id}
                className="flex cursor-pointer items-center justify-between gap-2 rounded-md border p-4"
                onClick={() => handleViewPrescription(report.reportData)}
              >
                <div className="flex gap-4">
                  <div className="shrink-0">
                    <PrescriptionIcon />
                  </div>
                  <div>
                    <h4 className="font-bold">
                    {report.reportName.length > 20 ? `${report.reportName.substring(0, 17)}...` : report.reportName}</h4>
                  </div>
                </div>
                <CircleChevronRight className="text-primary" />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default RecordPrescriptions;
